import useIsTestStudent from './useIsTestStudent';

export const RELEASED_FEATURES = [
  'courses-redesign',
  'cabinet-v2',
  'homework-direction-flags',
  'homework-path',
  'lesson-telegram-video',
  'study-group-link',
];

const usePreviewFeature = (feature) => {
  const isTestStudent = useIsTestStudent();

  return RELEASED_FEATURES.includes(feature) || isTestStudent;
};

export default usePreviewFeature;
